
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import MainButton from "../../../common/MainButton";
import Link from "next/link";
import classNames from "classnames";
const Feature = ({ feature, icons }) => {
    return <li className={'banner_features_item'}>
        {icons[feature.icon]}
        {feature.text.map(text => {
            return <p key={text}>{text}</p>;
        })}
    </li>;
};
const Banner = ({ banner, icons, type, larna }) => {
    const [isVideoPlay, setIsVideoPlay] = useState(false);
    const [isShowVideo, setIsShowVideo] = useState(false);
    const [videoElement, setVideoElement] = useState(undefined);
    // const [isVideoPlay, setIsVideoPlay] = useState(false);
    useEffect(() => {
        setVideoElement(document.getElementById('promo_video'));
    }, []);
    const addControls = (el) => {
        el.setAttribute('controls', 'controls');
    };
    const removeControls = (el) => {
        el.removeAttribute('controls');
    };
    const videoPlay = () => {
        document.body.style.overflow = 'hidden';
        videoElement.addEventListener('mouseover', () => addControls(videoElement));
        videoElement.addEventListener('mouseleave', () => removeControls(videoElement));
        if (videoElement.paused) {
            videoElement.play();
            setIsVideoPlay(true);
        }
        else {
            videoElement.pause();
            setIsVideoPlay(false);
        }
    };
    const videoStop = () => {
        document.body.style.overflow = 'auto';
        videoElement.addEventListener('mouseover', () => addControls(videoElement));
        videoElement.addEventListener('mouseleave', () => removeControls(videoElement));
        setIsShowVideo(false);
        videoElement.pause();
        setIsVideoPlay(false);
    };
    return (<section className={'banner'}>
            <div className="container">
                <div className={classNames({
            "banner_wrapper": true,
            [type]: type
        })}>
                    {type !== 'coldbook' && <div className={classNames({
                'video_popup': true,
                'open': isShowVideo
            })}>
                        <div className='video_content'>
                            <img width={20} height={28} onClick={() => videoStop()} className={'close_icon'} src={'/img/icons/close.png'} alt={'close'}/>
                            <video id='promo_video' src="/video/video.mp4" poster="/video/poster.png">
                                Sorry, your browser doesn't support embedded videos,
                                but don't worry, you can <a href="/video/video.mp4">download it</a>
                                and watch it with your favorite video player!
                            </video>
                        </div>
                    </div>}
                    <div className="banner_top">
                        <div className="banner_top_main">
                            <div className="main_label">
                                <p className={'main_label_name'}>{banner.label.text}</p>
                                <span className={'main_label_label'}>{banner.label.label}</span>
                            </div>
                            <h1 className="main_title">
                                <span>{banner.title_1}</span>
                                <span>{banner.title_2}</span>
                                <span>{banner.title_3}</span>
                            </h1>
                            <div className="main_cta">
                                <Link href={process.env.NEXT_PUBLIC_APP_URL}>
                                    <MainButton title={larna ? 'Pre-Order NOW' : banner.preorder_cta}/>
                                </Link>
                            </div>
                        </div>
                    </div>
                    {type !== 'coldbook' && <div className={`play_btn ${isVideoPlay ? 'playing' : ''}`}>
                        <img width={77} height={81} onClick={() => {
                setIsShowVideo(true);
                videoPlay();
            }} alt={'Larna 2400'} src={'/video/play.svg'}/>

                    </div>}
                    <ul className="banner_features">
                        {banner.features.map(feature => {
            return <Feature key={feature.icon} feature={feature} icons={icons}/>;
        })}
                    </ul>
                </div>
            </div>
        </section>);
};
export default Banner;

    async function __Next_Translate__getStaticProps__1973b766b49__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//hardware/Banner/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1973b766b49__ as getStaticProps }
  